import React from "react";

//ANT DESIGN IMPORTS
import {
    Card,
    Col,
    Divider,
    Row,
    Typography,
    Table
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig, } from "../../../../group.config";
import { log } from "@antv/g2plot/lib/utils";

const { Text } = Typography;

const Preview = (props) => {

    const {
        formData,
        clientMembersArray,
        templateProdDetail,
        chargeTableSource,
        customerInfo,
    } = props;

    const data = {
        details: [
            {
                name: "Product Name",
                value: formData?.details?.productId ? templateProdDetail?.productOptions?.find(
                    (item) => item.id === formData.details.productId
                ).name
                    : "-",
            },
            {
                name: "Submitted On",
                value: formData?.details?.submittedOnDate
                    ? formData.details.submittedOnDate
                    : "-",
            },
            {
                name: "Expected DisbursementDate",
                value: formData?.details?.expectedDisbursementDate
                    ? formData.details.expectedDisbursementDate
                    : "-",
            },
            {
                name: "Loan Officer",
                value: formData?.details?.loanOfficerId
                    ? templateProdDetail?.loanOfficerOptions?.find(
                        (item) => item.id === formData.details.loanOfficerId
                    ).displayName
                    : "-",
            },
            {
                name: "Fund",
                value: formData?.details?.fundId
                    ? templateProdDetail?.fundOptions?.find(
                        (item) => item.id === formData.details.fundId
                    ).name
                    : "-",
            },
        ],

        terms: [
            {
                name: labelConfig.day,
                value: formData?.terms?.day
                    ? templateProdDetail?.repaymentFrequencyDaysOfWeekTypeOptions?.find(
                        (item) => item.id === formData.terms?.day
                    ).value
                    : "-",
            },
            {
                name: "Interest Rate per Period",
                value: formData?.terms?.interestRatePerPeriod,
            },
            {
                name: "Interest charged from",
                value: formData?.terms?.interestChargedFromDate,
            },
            {
                name: "Repayments starting from",
                value: formData?.terms?.repaymentsStartingFromDate,
            },
            {
                name: "Interest Method",
                value: formData?.terms?.interestType
                    ? templateProdDetail?.interestTypeOptions?.find(
                        (item) => item.id === formData.terms?.interestType
                    )?.value
                    : "-",
            },
            {
                name: labelConfig.loanTermFrequency,
                value: `${formData?.terms?.loanTermFrequency} ${formData?.terms?.loanTermFrequencyType
                    ? templateProdDetail?.termFrequencyTypeOptions?.find(
                        (item) => item.id === formData.terms.loanTermFrequencyType
                    ).value
                    : "-"}`,
            },
            {
                name: labelConfig.numberOfRepayments,
                value: formData?.terms?.numberOfRepayments,
            },
            {
                name: labelConfig.on,
                value: formData?.terms?.on
                    ? templateProdDetail?.repaymentFrequencyNthDayTypeOptions?.find(
                        (item) => item.id === formData.terms.on
                    ).value
                    : "-",
            },
            {
                name: labelConfig.repaidEvery,
                value: `${formData?.terms?.repaymentEvery} ${formData?.terms?.repaymentFrequencyType
                    ? templateProdDetail?.termFrequencyTypeOptions?.find(
                        (item) => item.id === formData.terms.repaymentFrequencyType
                    ).value
                    : "-"}`,
            },
        ],
    };
    console.log(templateProdDetail);

    const columns = [
        [
            {
                key: " 1",
                title: "Name",
                dataIndex: "name",
            },
            {
                key: " 2",
                title: "Type",
                dataIndex: "type",
            },
            {
                key: " 3",
                title: "Amount",
                dataIndex: "amount",
            },
            {
                key: " 4",
                title: "Collected On",
                dataIndex: "collectedOn",
            },
            {
                key: " 5",
                title: "Date",
                dataIndex: "feeOnMonthDay",
            },
            {
                key: "6",
                title: "Repayments Every",
                dataIndex: "collectedOn",
            },
        ],
    ];

    const ClientsColumns = [
        {
            title: "Client ID",
            dataIndex: "clientId",
        },
        {
            title: "Client Name",
            dataIndex: "clientName",
        },
        {
            title: "Loan Purpose",
            dataIndex: "loanPurposeId",
        },
        {
            title: "Original Loan",
            dataIndex: "originalLoan",
        },
    ];

    return (
        <Card
            style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
        >
            {/* DETAILS FORM  */}
            <div
                style={{
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    marginBottom: 25,
                }}
            >
                <Divider orientation="left" orientationMargin="0">
                    {"Details"}
                </Divider>
                {data.details.map((detail, index) => {
                    const { name, value } = detail;

                    return (
                        <div
                            style={{
                                border: "2px solid #F5F5F5",
                                borderRadius: 15,
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomColor: "#E2E2E2",
                            }}
                            key={index}
                        >
                            <Row>
                                <Col
                                    span={12}
                                    style={{
                                        backgroundColor: "#F5F5F5",
                                        padding: 10,
                                        borderRadius: 15,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                        borderBottomLeftRadius: 0,
                                    }}
                                >
                                    <Text strong>{name}</Text>
                                </Col>
                                <Col
                                    span={12}
                                    style={{
                                        padding: 10,
                                    }}
                                >
                                    <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>

            {/* TERMS FORM  */}
            <div
                style={{
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    marginBottom: 25,
                }}
            >
                <Divider orientation="left" orientationMargin="0">
                    {"Terms"}
                </Divider>
                {data.terms.map((detail, index) => {
                    const { name, value } = detail;

                    return (
                        <div
                            style={{
                                border: "2px solid #F5F5F5",
                                borderRadius: 15,
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomColor: "#E2E2E2",
                            }}
                            key={index}
                        >
                            <Row>
                                <Col
                                    span={12}
                                    style={{
                                        backgroundColor: "#F5F5F5",
                                        padding: 10,
                                        borderRadius: 15,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                        borderBottomLeftRadius: 0,
                                    }}
                                >
                                    <Text strong>{name}</Text>
                                </Col>
                                <Col
                                    span={12}
                                    style={{
                                        padding: 10,
                                    }}
                                >
                                    <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>

            {/* SETTINGS FORM */}
            <div
                style={{
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    marginBottom: 25,
                }}
            >
                <Divider orientation="left" orientationMargin="0">
                    {"Settings"}
                </Divider>
                <Table
                    pagination={false}
                    columns={ClientsColumns}
                    dataSource={clientMembersArray}
                />
            </div>

            {/* CHARGES FORM */}
            <div
                style={{
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    marginBottom: 25,
                }}
            >
                <Divider orientation="left" orientationMargin="0">
                    {"Charges"}
                </Divider>
                <Table
                    pagination={false}
                    columns={columns[0]}
                    dataSource={chargeTableSource}
                />
            </div>
        </Card>
    );
};

export default Preview;
